module.exports = __webpack_public_path__ + "img/JUSTBIT.46304b8f.svg";